import { Button, Dialog, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import ModalHeader from '../../../../components/ModalHeader';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import { Form, Formik } from 'formik';
import { useRef } from 'react';
import { useTheme } from '@emotion/react';
import * as yup from 'yup';
import FormTextField from '../../../../components/FormTextField';
import { useDispatch, useSelector } from 'react-redux';
import PageHeader from '../../../../components/PageHeader';
import { CheckBox } from '@mui/icons-material';
import FileUploadField from '../../../../components/FileUploadField/FileUploadField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { CancelToken } from 'apisauce';
import Datatable from '../../../../components/DataTable';
import appapi from '../../../../api/apiClient';
import { useEffect } from 'react';
import uploadFileToS3 from '../../../../utils/fileUpload';
import { showmessage } from '../../../../utils/toastr';
import { setLoading } from '../../../../redux/features/appSlice';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

const validationSchema = yup.object({
  price: yup.number('price').required(' '),
  attachment: yup.string('Attachement').required(' '),
  euaRequired: yup.number('EUA Quantity').required(' '),
  remarks: yup.string('Remarks').min(3, 'Remarks should be atleast 3 character').max(300, 'Maximum Character Limit 300').required(' '),
});

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

export default function SendAdvisory({ modelOpen, onModelHandleClose }) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const {t} = useTranslation()

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '5%',
    },
    {
      id: 1,
      header: 'Client',
      accessor: 'displayName',
      width: '30%',
    },
    {
      id: 2,
      header: 'Designation',
      accessor: 'companyType',
      width: '25%',
      capitalize: true,
    },
    {
      id: 3,
      header: 'Email',
      accessor: 'email',
      width: '30%',
    },
  ];

  const [companyList, setCompanyList] = useState([]);
  const [loading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState(null);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedCompanyIds, setSelectedCompanyIds] = useState([]);

  let source = CancelToken.source();

  const { user } = useSelector((state) => state.auth);

  const getCompanyList = async () => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `trader/companyListForTrader/${user?.companyId}`,
      { filter },
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let arr = data?.response;
        arr.map((item, index) => {
          item.Sno = index + 1;
          item.isSelected = false;
          return item;
        });
        setCompanyList(arr);
      }
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const handleSearchEmit = (text) => {
    if (text) {
      setFilter(text.trim());
    } else {
      setFilter(text);
    }
  };

  useEffect(() => {
    getCompanyList();
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [filter]);

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    const companies = [...selectedCompanyIds];
    const ids = companies.map((res) => res.companyId);
    if (checkedStatus) {
      companies.push(item);
    } else {
      const index = ids.indexOf(item.companyId);
      if (index != -1) {
        companies.splice(index, 1);
      }
    }
    setSelectedCompanyIds(companies);
  };

  useEffect(() => {
    if (selectedCompanyIds.length > 0) {
      const items = companyList.map((res) => {
        return {
          ...res,
          isSelected: selectedCompanyIds.map((res) => res.companyId).includes(res.companyId),
        };
      });
      setCompanyList(items);
      setIsAllChecked(selectedCompanyIds.length === items.length)
    } else {
      const items = companyList.map((res) => {
        return {
          ...res,
          isSelected: false,
        };
      });
      setCompanyList(items);
      setIsAllChecked(false)
    }
  }, [selectedCompanyIds]);

  const handleFile = (file) => {
    if (file?.path) {
      formRef?.current?.setFieldValue('attachment', file);
    } else {
      formRef?.current?.setFieldValue('attachment', undefined);
    }
  };

  const handleSendAdvisory = async (values) => {
    dispatch(setLoading(true));
    if (values.attachment && values.attachment?.path) {
      try {
        values['attachment'] = await uploadFileToS3(values.attachment);
      } catch (e) {}
    }
    const payload = {
      companyIds: selectedCompanyIds,
      ...values,
    };
    const response = await appapi.post(`/trader/sendAdvisory`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        onModelHandleClose(true);
        showmessage(data.message);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        // className="!h-[100%]"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <ModalHeader
          label={t('SEND ADVISORY')}
          onClose={() => onModelHandleClose(false)}
        />
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />
        <Formik
          innerRef={formRef}
          enableReinitialize={false}
          initialValues={{
            traderId: user?.companyId,
            tradeType: 'buy',
            priceType: 'spot',
            requestType: 'advisory',
            price: '',
            validity: null,
            attachment: undefined,
            euaRequired: '',
            remarks: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSendAdvisory(values);
          }}
        >
          {({ name, values, touched, errors, handleChange, handleBlur, isValid, dirty, setFieldValue, setFieldTouched }) => (
            <Form
              className="flex flex-col flex-1"
              autoComplete="off"
            >
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px] p-[16px]"
              >
                <Typography
                  className="fw-regular ff-Roboto fs-16 !uppercase"
                  color={text}
                >
                  {t('Quote Details')}
                </Typography>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                  color={textLight}
                >
                {t('Some info may be visible to other people using ZeroEmission services')}
                </Typography>
                <Stack style={{ paddingBottom: '20px' }}>
                  <FileUploadField
                    placeholder={t('Upload File (CSV, XLSX, JSON, PDF)')}
                    url={values?.attachment ? values?.attachment : null}
                    inputId={`doc`}
                    handleFile={(files) => handleFile(files)}
                    showFileName={false}
                    bgColor={'#f3f4f7'}
                    enableExcel={true}
                  />
                </Stack>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mb-[8px] !capitalize"
                  color={text}
                >
                  {t('Trade type')}
                </Typography>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                >
                  <Stack
                    className="cursor-pointer"
                    style={{ backgroundColor: values?.tradeType === 'buy' ? '#003399' : '#8993AC1A', borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px', width: '104px', height: '40px', alignItems: 'center', justifyContent: 'center' }}
                    onClick={() => setFieldValue('tradeType', 'buy')}
                  >
                    <Typography color={values?.tradeType === 'buy' ? '#FFFFFF' : '#003399'}>{t('buy')}</Typography>
                  </Stack>
                  <Stack
                    className="cursor-pointer"
                    style={{ backgroundColor: values?.tradeType === 'sell' ? '#003399' : '#8993AC1A', borderTopRightRadius: '4px', borderBottomRightRadius: '4px', width: '104px', height: '40px', alignItems: 'center', justifyContent: 'center' }}
                    onClick={() => setFieldValue('tradeType', 'sell')}
                  >
                    <Typography color={values?.tradeType === 'sell' ? '#FFFFFF' : '#003399'}>{t('sell')}</Typography>
                  </Stack>
                </Stack>
                <Typography
                  className="fw-regular ff-Roboto fs-12 !mt-[18px] !mb-[8px] !capitalize"
                  color={text}
                >
                  {t('Select price type')}
                </Typography>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  className="mb-[18px]"
                >
                  <Stack
                    className="cursor-pointer"
                    style={{ backgroundColor: values?.priceType === 'spot' ? '#003399' : '#8993AC1A', borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px', width: '104px', height: '40px', alignItems: 'center', justifyContent: 'center' }}
                    onClick={() => setFieldValue('priceType', 'spot')}
                  >
                    <Typography color={values?.priceType === 'spot' ? '#FFFFFF' : '#003399'}>{t('spot')}</Typography>
                  </Stack>
                  <Stack
                    className="cursor-pointer"
                    style={{ backgroundColor: values?.priceType === 'future' ? '#003399' : '#8993AC1A', borderTopRightRadius: '4px', borderBottomRightRadius: '4px', width: '104px', height: '40px', alignItems: 'center', justifyContent: 'center' }}
                    onClick={() => setFieldValue('priceType', 'future')}
                  >
                    <Typography color={values?.priceType === 'future' ? '#FFFFFF' : '#003399'}>{t('future')}</Typography>
                  </Stack>
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('EUA Quantity')}
                    name="euaRequired"
                    requiredMark={true}
                    onlyNumber={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 10 }}
                  />
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Price / EUA')}
                    name="price"
                    requiredMark={true}
                    onlyFloat={true}
                    whiteSpace={true}
                    inputProps={{ maxLength: 10 }}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">€</InputAdornment>,
                    }}
                  />
                </Stack>
                <Stack className="mb-[20px]">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                     minDate={dayjs().set('hour', 0).set('minute', 0).set('second', 0)}
                      label={(t('Quote valid till') + ' *')}
                      value={values.validity}
                      timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
                      onChange={(newValue) => setFieldValue('validity', newValue)}
                      renderInput={(params) => (
                        <TextField
                          onKeyDown={(event) => {
                            event.preventDefault();
                          }}
                          {...params}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>
                <Stack>
                  <FormTextField
                    outlineLabel={t('Remark')}
                    name="remarks"
                    multiline={true}
                    maxRows={3}
                    requiredMark={true}
                    inputProps={{ maxLength: 301 }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        minHeight: '88px !important',
                        display: 'block',
                      },
                    }}
                  />
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
                className="m-[15px]"
              >
                <PageHeader
                  tableType={'2'}
                  headerColor={'#F2F3F580'}
                  showCloseBtn={true}
                  //   handleClose={handleClose}
                  handleOnSearchEmit={(search) => {
                    handleSearchEmit(search);
                  }}
                >
                  <Stack direction="row">
                    <Stack style={{ paddingLeft: '10px' }}>
                      <Typography
                        className="fs-16 ff-Roboto fw-regular"
                        color={'#14285A'}
                      >
                        {t('Add Client')}
                      </Typography>
                      <Typography
                        className="fs-12 ff-Roboto fw-regular"
                        color={'#8993AC'}
                      >
                        {t('Select clients to send request')}
                      </Typography>
                    </Stack>
                  </Stack>
                </PageHeader>
                <Datatable
                  tableHeadBgColor={'rgb(243 244 247)'}
                  columns={columns}
                  data={companyList || []}
                  isLoading={loading}
                  showCheckBox={true}
                  onChangeCheckBox={handleOnChangeCheckBox}
                  isAllChecked={isAllChecked}
                  onAllSelectCheckBox={(checkedStatus) => {
                    const arr = companyList.map((res) => {
                      return {
                        ...res,
                        isSelected: checkedStatus,
                      };
                    });
                    setSelectedCompanyIds(checkedStatus ? arr : []);
                  }}
                />
              </Stack>
              <Stack
                direction="row"
                justifyContent="flex-end"
                className="px-4 py-2 !justify-end p-[0px] sticky bottom-[0] !mt-[32px]"
                // className="!mt-[44px] h-[66px] "
                style={{ backgroundColor: '#FFFFFF', zIndex: 4 }}
              >
                <Button
                  sx={[
                    dialogButtonCancel,
                    {
                      color: theme.palette.primary.main,
                      '&:hover': {
                        // backgroundColor: theme.palette.secondary.main,
                        // color: theme.palette.background.main,
                        // borderColor: theme.palette.secondary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', marginLeft: '80px', height: '40px' }}
                  onClick={() => {
                    onModelHandleClose(false);
                  }}
                >
                  {t('Close')}
                </Button>
                <Button
                  sx={[
                    buttonStyle2,
                    {
                      color: '#fff',
                      backgroundColor: theme.palette.primary.main,
                      textTransform:'uppercase',
                      '&:hover': {
                        backgroundColor: theme.palette.background.main,
                        color: '#fff',
                      },
                      '&:disabled': {
                        color: 'rgba(255,255,255,0.5)',
                        backgroundColor: theme.palette.primary.main,
                      },
                    },
                  ]}
                  style={{ width: '128px', height: '40px' }}
                  disabled={!(dirty && isValid) || selectedCompanyIds.length === 0}
                  type="submit"
                  variant="contained"
                >
                  {t('Send')}
                </Button>
              </Stack>
            </Form>
          )}
        </Formik>
      </Stack>
    </Dialog>
  );
}
